import { Component } from '@angular/core';
import { MotifModule } from "@ey-xd/motif-wc-angular"; 
import { Observable, tap } from 'rxjs';
import { AuthenticationService } from '../core/service/auth/authentication.service';
import { Router } from '@angular/router';
import { AsyncPipe, CommonModule } from '@angular/common';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, MotifModule, AsyncPipe],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  loggedIn$: Observable<boolean>;

  // Zoom related properties for breakpoint observer
  isZoomed: boolean = false;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private breakpointObserver: BreakpointObserver
  ) {
    this.breakpointObserver
      .observe(['(max-width: 800px)'])
      .subscribe((result) => {
        this.isZoomed = result.matches;
      });

    this.loggedIn$ = this.authenticationService.isLoggedIn().pipe(
      tap((loggedIn) => {
        switch (loggedIn) {
          case true:
            try {
              this.authenticationService.initializeTokenManagement();
            } catch (error) {
              console.warn('Token management initialization skipped:', error);
            }
            return this.router.navigate(['home']);
          case false:
            console.log('login', false);
            return false;
          case null:
            console.log('login', null);
            return false;
        }
      })
    );
  }

  onClickLogin(): void {
    this.authenticationService.login();
  }
}
